import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {api} from "../utils/gashtaltAPI";
import "../assets/css/Entrance.css";
import Image from "../assets/images/index.svg";
import OtpInput from "../components/OTPInput";
import Loader from "../components/Loader";
import {toEnglishNumber} from "../utils/numberConversion";
import {login} from "../store/userSlice";
import {useDispatch} from "react-redux";

function ChangePassword() {
    const [otp, setOtp] = useState("");
    const [error, setError] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordConfirmation, setPasswordConfirmation] = useState("");
    const [passwordError, setPasswordError] = useState(false);
    const [passwordConfirmationError, setPasswordConfirmationError] =
        useState(false);
    const [loading, setLoading] = useState(false);
    const [seconds, setSeconds] = useState(0);
    const [isRunning, setIsRunning] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    useEffect(() => {
        if (!isRunning) return;
        if (seconds <= 0) setIsRunning(false)
        const interval = setInterval(() => {
            setSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);

        return () => {clearInterval(interval)}; // Cleanup interval on unmount or when stopped
    }, [isRunning, seconds]);

    const handleOtpChange = (value) => {
        setOtp(value);
    };
    const handlePassword = (e) => {
        const input = e.target.value;
        setPasswordError(input.length < 6);
        setPasswordConfirmationError(
            input !== passwordConfirmation && passwordConfirmation !== ""
        );
        setPassword(input);
    };

    const handlePasswordConfirmation = (e) => {
        const input = e.target.value;
        setPasswordConfirmationError(password !== input);
        setPasswordConfirmation(input);
    };
    const handleResendOTP = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post("/api/recoverPassword", {
                phone_number: localStorage["forgotten_password_phone_number"],
            });
            toast.success(response.data.message, {
                position: "bottom-right",
            });
            setIsRunning(true);
            setSeconds(120);
        } catch (error) {
            setLoading(false);
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right",
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right",
            });
        }
    }
    const handleSumbit = async (e) => {
        e.preventDefault();
        if (otp === "" || passwordConfirmation === "" || password === "" || error) {
            toast.error("فرم ورود را کامل کنید!", {
                position: "bottom-right",
            });

            return;
        }
        setLoading(true);
        try {
            const response = await api.post("/api/changePassword", {
                code: toEnglishNumber(otp),
                phone_number: localStorage["forgotten_password_phone_number"],
                password: password,
                password_confirmation: passwordConfirmation,
            });
            toast.success(response.data.message, {
                position: "bottom-right",
            });
            localStorage.removeItem('forgotten_password_phone_number');
            dispatch(
                login({
                    user: response.data.data.user,
                    token: response.data.data.token,
                })
            );
            navigate("/");
        } catch (error) {
            setLoading(false);
            if (error.response) {
                const status = error.response.status;
                if (status === 422 || status === 401 || status === 400) {
                    toast.error(error.response.data.message, {
                        position: "bottom-right",
                    });
                }
                return;
            } else if (error.request) {
                toast.error("اتصال اینترنت خود را بررسی کنید!", {
                    position: "bottom-right",
                });
                return;
            }
            toast.error("خطایی رخ داد!", {
                position: "bottom-right",
            });
        }
    };
    useEffect(() => {
        if (!localStorage["forgotten_password_phone_number"])
            navigate("/RecoverPassword");
        else {
            setIsRunning(true);
            setSeconds(120);
        }
    }, []);

    if (loading) return <Loader/>
    return (
        <>
            <div className="entrance-panel row">
                <div className="col-lg-6 form-div">
                    <h1>بازیابی رمزعبور</h1>
                    <h3>کد تایید ارسال شده و رمز عبور جدید خود را وارد کنید.</h3>
                    <form method="post" className="container" onSubmit={handleSumbit}>
                        <div className="custom-input-group col-12 col-lg-8">
                            <OtpInput length={6} onChange={handleOtpChange}/>
                        </div>
                        <button
                            className="submit-button btn btn-filled col-12 col-lg-8"
                            type="submit" disabled={isRunning || seconds!==0} onClick={handleResendOTP}
                        >
                            {isRunning || seconds!==0 ? `زمان باقی مانده : ${Math.floor(seconds / 60)}:${String(seconds%60).padStart(2, '0')}` : 'ارسال مجدد'}
                        </button>
                        <div className="custom-input-group col-12 col-lg-8 my-2 mb-1">
                            <input
                                type="password"
                                className="form-control"
                                value={password}
                                onChange={handlePassword}
                                placeholder="رمز عبور"
                            />
                            <p
                                className={`form-error ${passwordError ? "visible" : "hidden"}`}
                            >
                                رمز عبور باید حداقل 6 کاراکتر باشد!
                            </p>
                        </div>
                        <div className="custom-input-group col-12 col-lg-8 my-2 mb-0">
                            <input
                                type="password"
                                className="form-control"
                                value={passwordConfirmation}
                                onChange={handlePasswordConfirmation}
                                placeholder="تکرار رمز عبور"
                            />
                            <p
                                className={`form-error ${
                                    passwordConfirmationError ? "visible" : "hidden"
                                }`}
                            >
                                رمز عبور و تکرار آن یکسان نیستند!
                            </p>
                        </div>
                        <button
                            className="submit-button btn btn-filled col-12 col-lg-8"
                            type="submit"
                        >
                            ثبت
                        </button>
                        <div className="col-md-6 col-10 d-bloc mx-auto text-start my-1 back-link">
                            <a
                                onClick={() => {
                                    navigate("/login");
                                }}
                                className="link"
                            >
                                بازگشت
                            </a>
                        </div>
                    </form>
                </div>
                <div className="image-div col-6 hide-on-mobile">
                    <img src={Image} alt="خطا"/>
                </div>
            </div>
        </>
    );
}

export default ChangePassword;
